<template>
  <div class="all"> 
    <div class="changeName">
      <i></i>
         <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
       <!-- <span @click="$router.go(-1)">取消</span> -->
       <span>修改昵称</span>
       <span @click="successOne">完成</span>
    </div>
    <div class="bgOne"></div>
    <div class="userId">
      <img src="../../assets/images/personage.png" alt="">
      <input type="text" placeholder="请输入会员名称" v-model="userNmeid" maxlength="20"  ref="input"/>
      <div class="clear" @click="clearALL">x</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userNmeid: this.$store.state.person.oneChoose   //输入的会员名
    };
  },
  
  mounted() {
    this.$refs["input"].focus();
  },
  methods: {
    clearALL() {
      this.userNmeid = "";
      this.$refs["input"].focus();
    },
    successOne() {
      this.$store.commit('SET_PERSON',{oneChoose:this.userNmeid}); //输入的会员名
      this.$router.push({
        path: "/personage"
      });
    }
  }
};
</script>
<style scoped>
.el-icon-arrow-left{
    font-size: 0.75rem;
    line-height:1rem;
     margin-left: 0.2rem
}
.changeName {
  color: rgba(0, 0, 0, 0.9);
  font-size: 0.55rem;
  height: 1.6rem;
  position: relative;
  background: white;
}
.changeName span {
  display: inline-block;
  height: 1rem;
  line-height: 1.6rem;
  margin-left:2rem;
}
.changeName span:nth-child(2) {
  margin-left:3rem;
  font-size: 0.36rem;
}
.changeName span:nth-child(3) {
  margin-left: 2.8rem;
}
.bgOne {
  height: 0.25rem;
  background: rgba(0, 0, 0, 0.1);
}
.userId {
  font-size: 0;
  position: relative;
}
.userId img {
  height: 0.6rem;
  position: absolute;
  top: 0.42rem;
  left: 0.15rem;
}
input::-webkit-input-placeholder {  

font-size: 0.55rem;

} 
.userId input {
  display: inline-block;
  width: 100%;
  height:1.5rem;
  font-size: 0.55rem;
  text-indent: 1rem;
  border: none;
  outline: none;
  color: rgba(0, 0, 0, 0.9);
}
.all {
  height: 13.35rem;
  background: rgba(0, 0, 0, 0.1);
}
.clear {
  /* font-size: 0.55rem;
  color: white;
  height: 0.55rem;
  width: 0.55rem;
  background: rgba(0, 0, 0, 0.1);
  text-align: center;
  line-height: 0.55rem;
  border-radius: 50%;
  position: absolute;
  top: 0.45rem;
  left:8rem; */
}
</style>



// WEBPACK FOOTER //
// src/components/change/user.vue